import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { UnitSelect } from "../../Components/UnitSelect"
import { BlockField, BlockFieldInputs } from "../../Components/Block"
import { NumberInput } from "../../Components/Input"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipSingleRowDataItem } from "../../Components/ShipSingleRowDataItem"
import { IShipDataTank } from "../../Types"

interface ShipDataTankViewProps {
  data: IShipDataTank;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeTank: () => void;
}

export function ShipDataTankView({ data, editable, index, onEdited, removeTank }: ShipDataTankViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `tanks[${index}].`;

  { /* List for tanks */ }
  // Initialize tank with the value from data, or undefined if not present
  const [tank, setTank] = useState<string | undefined>(data.tankType);
  const predefinedTanks = ["fuel", "fuel_daytank", "water", "gray", "waste", "gas"];
  const selectTank = useCallback((value?: string) => {
    setTank(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  return (
    <ShipSingleRowDataItem namePrefix={namePrefix} id={data.id} rowClassName="one-row-list" onRemove={removeTank}>
      <BlockField label={t("tank")} className="block_field_small_14">
        <PredefinedSelect value={tank} predefined={predefinedTanks} label={(v) => t(`tank_${v}`)} customValue={t("other")} name={`${namePrefix}tankType`} onSelect={selectTank} readOnly={!editable} />
      </BlockField>

      <BlockField label={t("size")} className="block_field_small_8">
        <BlockFieldInputs>
          <NumberInput format="int" className="unit" name={`${namePrefix}capacity`} defaultValue={data.capacity} onChange={onEdited} readOnly={!editable} />
          <UnitSelect kind="volume" name={`${namePrefix}capacityUnit`} value={data.capacityUnit} editable={editable} onChange={onEdited} />
        </BlockFieldInputs>
      </BlockField>

      <BlockField label={t("place_installation")} className="block_field_small_16">
        <input name={`${namePrefix}placeInstallation`} defaultValue={data.placeInstallation} onChange={onEdited} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("comment")}>
        <input name={`${namePrefix}comment`} defaultValue={data.comment} onChange={onEdited} readOnly={!editable} />
      </BlockField>
    </ShipSingleRowDataItem>
  );
}
